import App from './containers/App';
import { Layout } from './core/Layout';
import { UserLayout } from './core/Layout/user';
import { FetchBoundary } from './core/fetch';
import DayJsUtils from '@date-io/dayjs';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import MaterialThemeProvider from './core/Layout/theme';
import { BrowserRouter, Routes } from 'react-router-dom';
import { useMediaQuery } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { AuthProvider } from './contexts/AuthContext';
import { Signup } from './containers/Signup';
import { Signin } from './containers/Signin';
import { ForgotPassword } from './containers/ForgotPassword';
import { PrivateRouteRoot } from './containers/PrivateRoute';
import { PrivateRouteLogin } from './containers/PrivateRoute';

const AppSuspense = () => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const [darkMode, setDarkMode] = useState(prefersDarkMode);
  const toggle = () => setDarkMode(!darkMode);

  if (window.location.pathname === '/') {
    window.location.pathname = '/login';
  }
  return (
    <React.StrictMode>
      <MaterialThemeProvider darkMode={darkMode}>
        <MuiPickersUtilsProvider utils={DayJsUtils}>
          <BrowserRouter>
            <FetchBoundary>
              <AuthProvider>
                <Routes>
                  <PrivateRouteLogin
                    exact
                    path="/app/*"
                    element={
                      <UserLayout darkMode={darkMode} toggleDarkMode={toggle}>
                        <App />
                      </UserLayout>
                    }
                  />
                  <PrivateRouteRoot
                    path="/signup"
                    element={
                      <Layout darkMode={darkMode} toggleDarkMode={toggle}>
                        <Signup />
                      </Layout>
                    }
                  />
                  <PrivateRouteRoot
                    path="/login"
                    element={
                      <Layout darkMode={darkMode} toggleDarkMode={toggle}>
                        <Signin />
                      </Layout>
                    }
                  />
                  <PrivateRouteRoot
                    path="/reset-password"
                    element={
                      <Layout darkMode={darkMode} toggleDarkMode={toggle}>
                        <ForgotPassword />
                      </Layout>
                    }
                  />
                </Routes>
              </AuthProvider>
            </FetchBoundary>
          </BrowserRouter>
        </MuiPickersUtilsProvider>
      </MaterialThemeProvider>
    </React.StrictMode>
  );
};
ReactDOM.render(<AppSuspense />, document.getElementById('root'));
